import { useTranslation } from 'react-i18next'
import { CardMedia, Stack, Typography } from '@mui/material'

import NoResults from '@/assets/svg/no-results.svg?react'
import { OfflineConsultation } from '@/core/offline'

import { OfflineConsultationsTable } from './OfflineConsultationsTable'

export const limitOptions = [5, 10, 15]

type OfflineConsultationsDesktopProps = {
  consultations?: OfflineConsultation[]
  loading?: boolean
  onPageChange?: (page: number) => void
  onRowsPerPageChange?: (rowsPerPage: number) => void
  page?: number
  rowsPerPage?: number
  totalCount?: number
}

export function OfflineConsultationsDesktop(props: OfflineConsultationsDesktopProps) {
  const { consultations = [], loading = false, onPageChange, onRowsPerPageChange, page = 1, rowsPerPage = limitOptions[0], totalCount = 0 } = props

  if (loading) {
    return <OfflineConsultationsSkeleton />
  }

  if (!consultations.length) {
    return <EmptyOfflineConsultations />
  }

  return (
    <OfflineConsultationsTable
      consultations={consultations}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={limitOptions}
      totalCount={totalCount}
    />
  )
}

function EmptyOfflineConsultations() {
  const { t } = useTranslation()
  return (
    <Stack direction="column" justifyContent="center" alignItems="center">
      <CardMedia component={NoResults} sx={{ width: 'auto', height: '250px', mt: '10px', mr: '40px' }} />
      <Typography component="div" variant="body1">
        {t('No offline consultations found')}
      </Typography>
    </Stack>
  )
}

function OfflineConsultationsSkeleton() {
  const { t } = useTranslation()
  return (
    <Stack direction="column" justifyContent="center" alignItems="center" sx={{ py: 4 }}>
      <Typography component="div" variant="body1">
        {t('Loading consultations...')}
      </Typography>
    </Stack>
  )
}
